import { requestJson } from "./apiClient";

/**
 * Unified Vehicle Market source catalog and action facade.
 * Merges automotive ops with vehicle compliance overlay — delegates to existing backends.
 */
export async function getVehicleMarketSources(options = {}) {
  return requestJson("/api/admin/vehicle-market/sources", {
    signal: options.signal,
  });
}

export async function runVehicleMarketSource(id, options = {}) {
  return requestJson(`/api/admin/vehicle-market/sources/${encodeURIComponent(id)}/run`, {
    method: "POST",
    body: JSON.stringify({
      dryRun: options.dryRun === true,
      useMock: options.useMock,
    }),
  });
}

export async function stopVehicleMarketSource(id) {
  return requestJson(`/api/admin/vehicle-market/sources/${encodeURIComponent(id)}/stop`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export async function enableVehicleMarketSourceSchedule(id, payload = {}) {
  return requestJson(
    `/api/admin/vehicle-market/sources/${encodeURIComponent(id)}/schedule/enable`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  );
}

export async function disableVehicleMarketSourceSchedule(id) {
  return requestJson(
    `/api/admin/vehicle-market/sources/${encodeURIComponent(id)}/schedule/disable`,
    {
      method: "POST",
      body: JSON.stringify({}),
    }
  );
}

export async function updateVehicleMarketSource(id, payload) {
  return requestJson(`/api/admin/vehicle-market/sources/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export async function getVehicleMarketSourceRuns(id, options = {}) {
  const params = new URLSearchParams();
  if (options.limit != null) {
    params.set("limit", String(options.limit));
  }
  const query = params.toString();
  return requestJson(
    `/api/admin/vehicle-market/sources/${encodeURIComponent(id)}/runs${
      query ? `?${query}` : ""
    }`,
    { signal: options.signal }
  );
}

export async function runVehicleMarketSourceDiscovery(id, options = {}) {
  return requestJson(
    `/api/admin/vehicle-market/sources/${encodeURIComponent(id)}/discovery/run`,
    {
      method: "POST",
      body: JSON.stringify({
        dryRun: options.dryRun === true,
        limit: options.limit,
      }),
    }
  );
}

export function formatVehicleMarketActionError(error) {
  if (!error) return "Unknown error.";
  const body = error.body || {};
  if (body.message) return body.message;
  if (body.blocker) return String(body.blocker).replace(/_/g, " ");
  return error.message || "Action failed.";
}
